/**
 * Shared device-list navigation payloads used from dashboard sections.
 */

/** Highest purchase/product cost first. */
export const DEVICES_BY_PRODUCT_COST_SORT = {
  sort_by: 'product_cost',
  sort_direction: 'desc',
};

/** Highest annual service-contract cost first. */
export const DEVICES_BY_CONTRACT_COST_SORT = {
  sort_by: 'service_contract_cost',
  sort_direction: 'desc',
};
